import React, { Component } from 'react'
import ReactDOM from 'react-dom';
import {
  Table,
  Grid,
  Loader
} from 'semantic-ui-react'

import find from 'lodash/find'

import './Facsimile.css'
import { formatName } from '../../utils/nameUtils'

const _ = {
  find: find
}

class FacsimilePopup extends Component {

  constructor(props) {
    super(props);
    this.state = {
      sectionSubjects: [],
      sectionStudent: null,
      summary: null,
      daysOfSchool: null,
      attendance: null,
      schoolYear: null,
      init: false
    };
    this.container = document.createElement('div');
    this.externalWindow = null;
  }

  _cloneStyles(doc, thisdoc) {
    Array.from(doc.styleSheets).forEach(styleSheet => {
      if (styleSheet.cssRules) { // for <style> elements
        const thisStyleEl = doc.createElement('style');
        Array.from(styleSheet.cssRules).forEach(cssRule => {
          thisStyleEl.appendChild(doc.createTextNode(cssRule.cssText));
        });
        thisdoc.head.appendChild(thisStyleEl);
      } else if (styleSheet.href) { // for <link> elements loading CSS from a URL
        const thisLinkEl = doc.createElement('link');
        thisLinkEl.rel = 'stylesheet';
        thisLinkEl.href = styleSheet.href;
        thisdoc.head.appendChild(thisLinkEl);
      }
    });
  }

  componentDidMount() {
    const {
      sectionStudent, sectionSubjects, summary, daysOfSchool, attendance, schoolYear
    } = this.props;
    this.container.style.cssText = 'padding:5px;font-family: Open Sans;overflow:auto';
    this.externalWindow = window.open('', '', 'width=1240,height=500,left=150,top=200', false);

    this.externalWindow.document.title =`Report Card for ${formatName(sectionStudent.student.lastName)}, ${formatName(sectionStudent.student.firstName)}`;
    this.externalWindow.document.body.appendChild(this.container);
    this.externalWindow.addEventListener('beforeunload', this.props.onClose);
    this._cloneStyles(document, this.externalWindow.document);

    this.setState({sectionStudent, sectionSubjects, summary, daysOfSchool, attendance, schoolYear, init: true}, () => {
      this.externalWindow.document.body.appendChild(this.container);
    })
  }

  componentWillUnmount() {
    this.externalWindow.close();
  }

  render() {
    const {
      sectionStudent, sectionSubjects, summary, daysOfSchool, attendance, schoolYear
    } = this.state;

    if (!this.state.init) {
      return (
        <div style={{height: '250px', width: '100%'}}>
          <div style={{display: 'inline-block', verticalAlign: 'middle', height: '250px'}} />
          <div style={{display: 'inline-block', verticalAlign: 'middle', width: '100%'}}>
            <Loader inline='centered' active />
          </div>
        </div>
      )
    }

    const subjectBody = summary.grades.map((grade, key )=> {
      const subject = _.find(sectionSubjects, {
        sectionSubjectId: grade.sectionSubjectId
      });
      if(subject === undefined) {
        return null;
      } else {
        return (
          <Table.Row key={key} className='students-table-row'>
            <Table.Cell>{subject.subject.name}</Table.Cell>
            <Table.Cell>{grade.firstQuarter}</Table.Cell>
            <Table.Cell>{grade.secondQuarter}</Table.Cell>
            <Table.Cell>{grade.thirdQuarter}</Table.Cell>
            <Table.Cell>{grade.fourthQuarter}</Table.Cell>
            <Table.Cell>{grade.fourthQuarter}</Table.Cell>
            <Table.Cell>PASSED</Table.Cell>
          </Table.Row>
        );
      }

    });

    const content = (
      <div>
        <Grid>
          <Grid.Row>
            <Grid.Column width={10}>
              <p>
                Name: {formatName(sectionStudent.student.lastName)}, {formatName(sectionStudent.student.firstName)} <br />
                Address: {formatName(sectionStudent.student.address)} <br />
                School Year: {schoolYear.name}
              </p>
            </Grid.Column>
            <Grid.Column width={6}>
              <p>
                LRN:  {sectionStudent.student.lrn} <br />
                Sex: {sectionStudent.student.gender} <br />
              Section: {sectionStudent.section.gradeLevel} - {sectionStudent.section.name}
              </p>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={10}>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell rowSpan='2' textAlign='center'>Subject</Table.HeaderCell>
                    <Table.HeaderCell colSpan='5' textAlign='center'>Grades</Table.HeaderCell>
                    <Table.HeaderCell rowSpan='2' textAlign='center'>Action Taken</Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell collapsing>1st</Table.HeaderCell>
                    <Table.HeaderCell collapsing>2nd</Table.HeaderCell>
                    <Table.HeaderCell collapsing>3rd</Table.HeaderCell>
                    <Table.HeaderCell collapsing>4th</Table.HeaderCell>
                    <Table.HeaderCell collapsing>Final</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {subjectBody}
                </Table.Body>
              </Table>
            </Grid.Column>
            <Grid.Column width={6}>
              <Table celled>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign='center' style={{paddingTop: '36px', paddingBottom: '36px'}}>Quarter</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>Remarks</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell>1st</Table.Cell>
                    <Table.Cell>Sample lala lala</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>2nd</Table.Cell>
                    <Table.Cell>he good worth yea yea</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>3rd</Table.Cell>
                    <Table.Cell>Boom na na ana</Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell>4th</Table.Cell>
                    <Table.Cell>Shake it off alalal</Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column width={16}>
              <Table celled compact size='small'>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell textAlign='center'>ATTENDANCE</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>JUN</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>JUL</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>AUG</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>SEP</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>OCT</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>NOV</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>DEC</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>JAN</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>FEB</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>MAR</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>APR</Table.HeaderCell>
                    <Table.HeaderCell textAlign='center'>TOTAL</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  <Table.Row>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      Days of School
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.junDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.julDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.augDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.sepDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.octDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.novDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.decDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.janDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.febDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.marDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.aprDays}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {daysOfSchool.totalDays}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      Days Present
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.jun}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.jul}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.aug}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.sep}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.oct}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.nov}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.dec}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.jan}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.feb}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.mar}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.apr}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.total}
                    </Table.Cell>
                  </Table.Row>
                  <Table.Row>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      Times Tardy
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.junTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.julTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.augTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.sepTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.octTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.novTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.decTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.janTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.febTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.marTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.aprTardy}
                    </Table.Cell>
                    <Table.Cell
                      className='attendance-table-cell-sample'
                      textAlign='center'
                      collapsing
                    >
                      {attendance.totalTardy}
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              </Table>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </div>
    )
    return ReactDOM.createPortal(content, this.container);
  }
}

export default FacsimilePopup;
